import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '../../constants/routes';
import { DashboardSlider } from './components/DashboardSlider';
import { LandingHeader } from './components/LandingHeader';
import { OcppTrace } from './components/OcppTrace';
import { useLandingFonts } from './components/useLandingFonts';
import './landing.css';

const CAPABILITIES = [
  'protocol',
  'sessions',
  'money',
  'network',
  'people',
  'balancing',
];

const FIGURES = ['protocolFigure', 'connectorFigure', 'currencyFigure'];

export const Landing = () => {
  const { t } = useTranslation();
  useLandingFonts();

  return (
    <div className="lp-root">
      <LandingHeader />

      <main>
        <section className="lp-hero">
          <div className="lp-shell lp-hero__inner">
            <div className="lp-hero__copy">
              <p className="lp-eyebrow">{t('landing.hero.eyebrow')}</p>
              <h1 className="lp-hero__title">{t('landing.hero.title')}</h1>
              <p className="lp-hero__lede">{t('landing.hero.lede')}</p>

              <div className="lp-hero__actions">
                <Link
                  to={`/${ROUTES.ORGANISATION_LOGIN}`}
                  className="lp-btn lp-btn--primary"
                >
                  {t('landing.hero.primaryCta')}
                </Link>
                <a href="#dashboard" className="lp-btn lp-btn--ghost">
                  {t('landing.hero.secondaryCta')}
                </a>
              </div>
            </div>

            <OcppTrace />
          </div>
        </section>

        <section className="lp-section lp-section--light" id="dashboard">
          <div className="lp-shell">
            <header className="lp-section__head">
              <p className="lp-eyebrow lp-eyebrow--dark">
                {t('landing.slider.eyebrow')}
              </p>
              <h2 className="lp-section__title">{t('landing.slider.title')}</h2>
              <p className="lp-section__lede">{t('landing.slider.lede')}</p>
            </header>

            <DashboardSlider />
          </div>
        </section>

        <section className="lp-section lp-section--ink">
          <div className="lp-shell">
            <header className="lp-section__head">
              <p className="lp-eyebrow">{t('landing.capabilities.eyebrow')}</p>
              <h2 className="lp-section__title">
                {t('landing.capabilities.title')}
              </h2>
            </header>

            <ul className="lp-caps">
              {CAPABILITIES.map((id) => (
                <li key={id} className="lp-caps__item">
                  <h3 className="lp-caps__title">
                    {t(`landing.capabilities.${id}.title`)}
                  </h3>
                  <p className="lp-caps__body">
                    {t(`landing.capabilities.${id}.body`)}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="lp-section lp-section--light lp-section--tight">
          <div className="lp-shell lp-figures">
            {FIGURES.map((id) => (
              <div key={id} className="lp-figure">
                <span className="lp-figure__value">
                  {t(`landing.figures.${id}.value`)}
                </span>
                <span className="lp-figure__label">
                  {t(`landing.figures.${id}.label`)}
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className="lp-section lp-section--ink lp-closing">
          <div className="lp-shell lp-closing__inner">
            <h2 className="lp-closing__title">{t('landing.closing.title')}</h2>
            <p className="lp-closing__lede">{t('landing.closing.lede')}</p>
            <Link
              to={`/${ROUTES.ORGANISATION_LOGIN}`}
              className="lp-btn lp-btn--primary"
            >
              {t('landing.closing.cta')}
            </Link>
            <p className="lp-closing__note">{t('landing.closing.note')}</p>
          </div>
        </section>
      </main>

      <footer className="lp-footer">
        <div className="lp-shell lp-footer__inner">
          <span>{t('landing.footer.rights')}</span>
          <nav className="lp-footer__links">
            <Link to={`/${ROUTES.TERMS_OF_USAGE}`}>
              {t('landing.footer.terms')}
            </Link>
            <Link to={`/${ROUTES.LOGIN}`}>{t('landing.footer.driver')}</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
